import { buttonVariants } from '@heidi/design-system/button';
import { Skeleton } from '@heidi/design-system/skeleton';
import { cn } from '@heidi/utils';
import { useMemo } from 'react';

const getRandomWidth = (min: number, max: number) => {
  return Math.floor(Math.random() * (max - min + 1)) + min;
};

export const SessionsListLoading = () => {
  // Generate random widths once per mount
  const randomWidths = useMemo(
    () =>
      Array.from({ length: 20 }).map((_, index) => ({
        title: getRandomWidth(40, 80),
        date: getRandomWidth(25, 35),
        showDate: index === 0 || Math.random() > 0.5,
      })),
    []
  );

  return (
    <div className="flex h-full flex-col gap-2 py-1">
      {randomWidths.map((widths, index) => (
        <div key={index} className="flex w-full max-w-xs flex-col">
          {widths.showDate && (
            <div className="p-1.5">
              <Skeleton className="h-[10px]" style={{ width: `${widths.date}%` }} />
            </div>
          )}
          <div
            className={cn(
              buttonVariants({
                variant: 'ghost',
                size: 'xxs',
              }),
              'h-fit w-full gap-2'
            )}
          >
            <Skeleton className="size-6 rounded-full" />
            <div className="flex flex-1 flex-col gap-1">
              <Skeleton className="h-[12px]" style={{ width: `${widths.title}%` }} />
              <div className="flex items-center gap-1">
                <Skeleton className="size-1.5 rounded-full" />
                <Skeleton className="h-[10px] w-[40px]" />
              </div>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};
